import { Component, ViewChild } from '@angular/core';
import { MachineHistorySearchComponent } from '../../Core/Shared/MachineHistoryComponent/MachineHistorySearch.component';

@Component({
  selector: 'OtherMachineHistory',
  templateUrl: './OtherMachineHistory.component.html',

})
export class OtherMachineHistoryComponent {
}